const DEFAULT_OPTIONS = {
  includeBom: true,
  lineEnding: '\r\n',
  quoteAllFields: true,
  formulaProtection: true,
};

const STRUCTURAL_BREAK_REGEX =
  /<\s*br\s*\/?>|<\/\s*p\s*>|<\/\s*div\s*>|<\/\s*li\s*>|<\/\s*h[1-6]\s*>/gi;
const REMAINING_TAGS_REGEX = /<[^>]*>/g;
const LEADING_FORMULA_REGEX = /^[=+\-@]/;

const decodeHtmlEntities = value =>
  value
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&nbsp;/g, ' ');

export const normalizeRichText = value => {
  if (value == null) return '';

  return decodeHtmlEntities(String(value))
    .replace(STRUCTURAL_BREAK_REGEX, '\n')
    .replace(REMAINING_TAGS_REGEX, '')
    .replace(/\r\n|\r/g, '\n');
};

export const normalizeValue = (value, column = {}, options = DEFAULT_OPTIONS) => {
  let normalized;

  if (value == null) {
    normalized = '';
  } else if (typeof value === 'string') {
    normalized = value;
  } else if (typeof value === 'number' || typeof value === 'boolean') {
    normalized = String(value);
  } else {
    normalized = JSON.stringify(value);
  }

  if (column.richText) {
    normalized = normalizeRichText(normalized);
  } else {
    normalized = String(normalized).replace(/\r\n|\r/g, '\n');
  }

  if (options.formulaProtection && LEADING_FORMULA_REGEX.test(normalized)) {
    normalized = `'${normalized}`;
  }

  return normalized;
};

export const escapeCsvField = (value, options = DEFAULT_OPTIONS) => {
  const stringValue = value == null ? '' : String(value);
  const escaped = stringValue.replace(/"/g, '""');

  if (options.quoteAllFields) {
    return `"${escaped}"`;
  }

  if (
    escaped.includes(',') ||
    escaped.includes('"') ||
    escaped.includes('\n') ||
    escaped.includes('\r') ||
    escaped.trim() !== escaped
  ) {
    return `"${escaped}"`;
  }

  return escaped;
};

const getColumnValue = (row, column) => {
  if (typeof column.accessor === 'function') {
    return column.accessor(row);
  }

  return row?.[column.key];
};

export const serializeCsv = ({ rows = [], columns = [], options = {} }) => {
  const config = { ...DEFAULT_OPTIONS, ...options };
  const headerRow = columns.map(column => escapeCsvField(column.header ?? '', config)).join(',');

  const dataRows = rows.map(row =>
    columns
      .map(column => {
        const rawValue = getColumnValue(row, column);
        const formattedValue =
          typeof column.format === 'function' ? column.format(rawValue, row) : rawValue;
        const normalizedValue = normalizeValue(formattedValue, column, config);

        return escapeCsvField(normalizedValue, config);
      })
      .join(',')
  );

  const csvRows = [headerRow, ...dataRows].join(config.lineEnding);

  return config.includeBom ? `\uFEFF${csvRows}` : csvRows;
};

export default serializeCsv;
